import { render, staticRenderFns } from "./Create_MessgeCard.vue?vue&type=template&id=f0cc64ae&scoped=true&"
import script from "./Create_MessgeCard.vue?vue&type=script&lang=js&"
export * from "./Create_MessgeCard.vue?vue&type=script&lang=js&"
import style0 from "./Create_MessgeCard.vue?vue&type=style&index=0&id=f0cc64ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cc64ae",
  null
  
)

export default component.exports